import { create } from "zustand";

interface AuthClaims {
  guilds?: Record<string, true>;
  guildAdmin?: Record<string, true>;
  admin?: boolean;
}

interface AuthState {
  uid: string | null;
  claims: AuthClaims | null;
  ready: boolean;
  setAuth: (uid: string, claims: AuthClaims | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  uid: null,
  claims: null,
  ready: false,
  setAuth: (uid, claims) => set({ uid, claims, ready: true }),
  clear: () => set({ uid: null, claims: null, ready: false }),
}));
